import React, { ReactElement } from "react";

export const cellFormatter = (bedrag: number, decimals?: number, currency?: boolean): string => {
  const options: Intl.NumberFormatOptions = {
    minimumFractionDigits: decimals || 0,
    maximumFractionDigits: decimals || 0
  };

  if (currency) {
    options.style = "currency";
    options.currency = "EUR";
  } else {
    options.style = "decimal";
  }

  return new Intl.NumberFormat("nl-NL", options).format(bedrag);
};

export const cellBedragFormat = (
  bedrag: number | null,
  decimals?: number,
  afrondenBoven?: number | boolean,
  currency = true
): ReactElement => {
  if (
    bedrag &&
    (typeof afrondenBoven === "number" || typeof afrondenBoven === "undefined") &&
    Math.abs(bedrag) > (afrondenBoven ?? 1000)
  )
    bedrag = Math.round(bedrag);

  return React.createElement(
    "div",
    { style: { textAlign: "right", width: "6rem" } },
    cellFormatter(bedrag || 0, decimals, currency)
  );
};
